import React from 'react';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { formatNumberLength } from '../../helpers';
import dayjs from 'dayjs';

//Estilos
import './NewGuiaBodega.css';
import TableContainer from '../../components/table/TableContainer';

function NewGuiaBodega({ functions, states }) {
    const { grapesVariety, masters } = useGlobalContext();
    const {
        ItemsBodegaTableData,
        SignedGuia,
        GuiaData,
        GuiaData: { itemsProductor, itemsBodega },
        Coordinates,
        GrapesVariety,
    } = states;

    const { handleSubmit, formatNumber, setOpenModal, onSubmit } = functions;

    return (
        <div className="new_guia_bodega-container">
            <h4 className="new_guia_bodega-title">
                Guía {GuiaData?.cabecera?.serie}-G-
                {formatNumber(GuiaData?.cabecera?.numero)}
            </h4>
            {!SignedGuia && (
                <form
                    className="new_guia_bodega-form"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <label className="new_guia_bodega-label">
                        <div>
                            <span>Habilitada: </span>
                            <p>{GuiaData?.cabecera?.estado ? 'SI' : 'NO'}</p>
                        </div>
                    </label>
                    <label className="new_guia_bodega-label">
                        <div>
                            <span>Matrícula Transporte: </span>
                            <p>{GuiaData?.cabecera?.matricula_Vehiculo}</p>
                        </div>
                    </label>
                    {GuiaData?.cabecera?.guia_Papel ? (
                        <label className="new_guia_bodega-label">
                            <div>
                                <span>Guía papel: </span>
                                <p>{GuiaData?.cabecera?.guia_Papel}</p>
                            </div>
                        </label>
                    ) : null}
                    <label className="new_guia_bodega-label">
                        <div>
                            <span>Viñedo: </span>
                            <p>{GuiaData?.cabecera?.viniedo}</p>
                        </div>
                    </label>
                    <label className="new_guia_bodega-label">
                        <div>
                            <span>Titular Viñedo: </span>
                            <p>{GuiaData?.cabecera?.titular_Viniedo}</p>
                        </div>
                    </label>
                    <label className="new_guia_bodega-label">
                        <div>
                            <span>Titular destinatario: </span>
                            <p>{GuiaData?.cabecera?.titular_Destinatario}</p>
                        </div>
                    </label>
                    <label className="new_guia_bodega-label">
                        <div>
                            <span>Tipo documento: </span>
                            <p>
                                {
                                    masters.DocumentTypes?.find(
                                        (ht) =>
                                            ht.id ===
                                            GuiaData?.cabecera?.doc_id_tipo
                                    )?.nombre
                                }
                            </p>
                        </div>
                    </label>
                    <label className="new_guia_bodega-label">
                        <div>
                            <span>Número Documento: </span>
                            <p>{GuiaData?.cabecera?.doc_id}</p>
                        </div>
                    </label>
                    <label className="new_guia_bodega-label">
                        <div>
                            <span>Ubicación viñedo: </span>
                            <p>
                                Latitud:{' '}
                                {formatNumberLength(
                                    GuiaData?.cabecera?.ubicacion_Viniedo_x
                                )}
                                , Longitud:{' '}
                                {formatNumberLength(
                                    GuiaData?.cabecera?.ubicacion_Viniedo_y
                                )}
                            </p>
                        </div>
                    </label>
                    <label className="new_guia_bodega-label">
                        <div>
                            <span>Depto. viñedo: </span>
                            <p>{GuiaData?.cabecera?.departamento_Viniedo}</p>
                        </div>
                    </label>
                    <label className="new_guia_bodega-label">
                        <div>
                            <span>Ubicación destinatario: </span>
                            <p>{GuiaData?.cabecera?.ubicacion_Destinatario}</p>
                        </div>
                    </label>
                    <label className="new_guia_bodega-label">
                        <div>
                            <span>Depto. destinatario: </span>
                            <p>
                                {masters?.Departments?.find(
                                    (d) =>
                                        d.id ===
                                        GuiaData?.cabecera
                                            ?.departamento_Destinatario
                                )?.nombre.replaceAll('_', ' ')}
                            </p>
                        </div>
                    </label>
                    <label className="new_guia_bodega-label">
                        <div>
                            <span>Destino: </span>
                            <p>
                                {masters?.Destinos?.find(
                                    (d) => d.id === GuiaData?.cabecera?.destino
                                )?.nombre.replaceAll('_', ' ')}
                            </p>
                        </div>
                    </label>

                    <h4 className="new_guia_bodega-title">Uva Enviada</h4>
                    <section className="guia-info-section">
                        <table>
                            <thead>
                                <tr>
                                    <th>Variedad</th>
                                    <th>Kilos Ingresados</th>
                                    <th>Precio Kg</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemsProductor?.map((it, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>
                                                {
                                                    GrapesVariety?.find(
                                                        (gv) =>
                                                            gv.codigo ===
                                                            it.variedad
                                                    )?.variedad
                                                }
                                            </td>
                                            <td>{it.kilos} kg</td>
                                            <td>${it.precio_Kg}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </section>

                    <footer className="new_guia_bodega-footer">
                        <label>
                            <span>Total Kilos Enviados: </span>
                            <p>{GuiaData?.cabecera?.total_Kilos} kg</p>
                        </label>
                        <label>
                            <span>Fecha de Envío: </span>
                            <p>
                                {dayjs(GuiaData?.cabecera?.fecha_Envio).format(
                                    'DD-MM-YYYY'
                                )}
                            </p>
                        </label>
                        <label>
                            <span>Firma del Viticultor: </span>
                            <p>{GuiaData?.cabecera?.firma_Viticultor}</p>
                        </label>
                    </footer>

                    {!GuiaData?.cabecera?.fecha_Recepcion ? (
                        <TableContainer tableData={ItemsBodegaTableData} />
                    ) : (
                        <section className="guia-info-section">
                            <h4 className="new_guia_bodega-title">
                                Uva Recibida
                            </h4>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Variedad</th>
                                        <th>Kilos en balanza</th>
                                        <th>Grado glucosa</th>
                                        <th>Precio Kg</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {itemsBodega?.map((it, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>
                                                    {
                                                        GrapesVariety?.find(
                                                            (gv) =>
                                                                gv.codigo ===
                                                                it.variedad
                                                        )?.variedad
                                                    }
                                                </td>
                                                <td>{it.kilos} kg</td>
                                                <td>{it.grado_Gluc}</td>
                                                <td>${it.precio_Kg}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </section>
                    )}

                    {GuiaData?.cabecera?.fecha_Recepcion ? (
                        ' '
                    ) : (
                        <div className="new_guia_bodega-footer">
                            <button
                                type="button"
                                className="btn btn-primary btn-submit-new_guia_bodega"
                                onClick={() => setOpenModal(true)}
                            >
                                Firmar Digitalmente
                            </button>
                        </div>
                    )}
                </form>
            )}
            {SignedGuia && <h3>La guía ha sido firmada exitosamente</h3>}
        </div>
    );
}

export default NewGuiaBodega;
